// extracted by mini-css-extract-plugin
export default {"thanks":"thanks_thanks__KhIEe"};